import { SearchAndListings, DetailsAndPayment } from './Home';

const Lodge = {
  SearchAndListings,
  DetailsAndPayment,
};

export default Lodge;



// WEBPACK FOOTER //
// ./src/screens/Lodge/index.js